import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewHistoryComponent } from './view-history.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    ViewHistoryComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    ViewHistoryComponent
  ]
})
export class ViewHistoryModule { }
